<template>
  <div class="main">
    <section class="light-content">
      <div class="container">
        <div class="text text-primary">
          <text-lang :lang="lang">
            <template slot="es">Página no encontrada</template>
            <template slot="en">Page not found</template>
          </text-lang>
        </div>
      </div>
    </section>

    <section class="light-content">
      <div class="container">
        <p class="title-content">
            <text-lang :lang="lang">
            <template slot="es">¿Estás seguro de que la URL del sitio web es correcta?</template>
            <template slot="en">Are you sure the website URL is correct?</template>
            </text-lang>
        </p>
        <p class="text text-secondary">
            <text-lang :lang="lang">
            <template slot="es">Buscamos esta página en todas partes.</template>
            <template slot="en">We looked everywhere for this page.</template>
            </text-lang>
        </p>
        <p class="text text-secondary">
            <text-lang :lang="lang">
            <template slot="es">Póngase en contacto con el propietario del sitio.</template>
            <template slot="en">Get in touch with the site owner.</template>
            </text-lang>
        </p>
        <router-link class="button" :to="{name: 'Home'}" style="width: 200px">
            <text-lang :lang="lang">
            <template slot="es">Regresar al inicio</template>
            <template slot="en">Go Back Home</template>
            </text-lang>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import ListContent from '@/components/ListContent.vue'
import ListContentItem from '@/components/ListContentItem.vue'
import TextLang from '@/components/TextLang.vue'

export default {
  name: 'NotFound',
  props: ['lang'],
  components: {
    ListContent,
    ListContentItem,
    TextLang
  }
}
</script>
